export interface FirebaseProperties {
	email: string;
	name: string;
}

export enum SCOPE_TYPE {
	Chat = 'chat',
	Caledar = 'calendar',
	Account = 'account',
	ABExperiment = 'ABExperiment',
	Office = 'office',
	Header = 'header',
	Payment = 'payment',
	Contact = 'contact',
	Promptuary = 'promptuary',
	Session = 'session',
	Appointment = 'appointment',
	AppointmentReposition = 'appointmentReposition',
	OnSiteSessions = 'onsite-sessions',
	VideoConference = 'vc',
	InactiveCustomers = 'inactive-customers',
	Insights = 'insights',
}

export enum SUBSCOPE_TYPE {
	FollowUp = 'followUp',
	Messages = 'messages',
	MenuItem = 'menu-item',
	Conference = 'vc',
	Sidebar = 'sidebar',
	Session = 'session',
	Plan = 'plan',
	Checkout = 'checkout',
	Moodtracker = 'mood',
	Invite = 'invite',
	InviteConflict = 'inviteConflict',
	Address = 'address',
	Export = 'export',
	Profile = 'profile',
	List = 'list',
	Banner = 'banner',
	Details = 'details',
	SpeechToText = 'speechToText',
	InactiveBulkMessage = 'inactiveBulkMessage',
	CustomBulkMessage = 'customBulkMessage',
	RecurrencyAttempt = 'recurrencyAttempt',
	Notification = 'notification',
	Reposition = 'reposition',
	Cgi = 'cgi',
	Outcome = 'outcome',
}

export enum ITEM_TYPE {
	Task = 'task',
	CancelSingle = 'cancelSingle',
	CancelAll = 'cancelAll',
	Send = 'send',
	PromptuariesFilter = 'promptuariesFilter',
	BtnAvailability = 'btnAvailability',
	BtnRequest = 'btnRequest',
	BtnCancel = 'btnCancel',
	List = 'list',
	Conversation = 'conversation',
	Error = 'error',
	Premium = 'premium',
	Analytics = 'analytics',
	RegisteredView = 'registeredView',
	HasResults = 'hasResults',
	NoResults = 'noResults',
	Search = 'search',
	OrderByAlfDesc = 'orderByAlfabeticalDesc',
	OrderByAlfAsc = 'orderByAlfabeticalAsc',
	OrderBySessionsAsc = 'OrderByOlderSessions',
	OrderBySessionsDesc = 'OrderByNewestSessions',
	BtnStatus = 'btnStatus',
	BtnSchedule = 'btnSchedule',
	BtnEdit = 'btnEdit',
	BtnChat = 'btnChat',
	BtnClose = 'btnClose',
	BtnAdd = 'btnAdd',
	BtnArchive = 'btnArchive',
	ReasonSugestion = 'ReasonSugestion',
	BtnTriage = 'btnTriage',
	BtnContact = 'btnGoToContact',
	BtnRegister = 'btnRegister',
	BtnPromptuary = 'btnPromptuary',
	BtnPromptuaryList = 'btnPromptuaryList',
	planFullHour = 'planFullHour',
	BtnRegisterList = 'btnRegisterList',
	Definitions = 'definitions',
	BtnView = 'btnView',
	Card = 'card',
	Cart = 'cart',
	Init = 'init',
	Client = 'client',
	ModalRegister = 'modalRegister',
	Professional = 'professional',
	Status = 'status',
	Tab = 'tab',
	Filter = 'filter',
	Reccomend = 'reccomend',
	Permission = 'permission',
	Submit = 'submit',
	Create = 'create',
	Cancel = 'cancel',
	Link = 'link',
	Edit = 'edit',
	Click = 'click',
	Remove = 'remove',
	Redirect = 'redirect',
	Sidebar = 'sidebar',
	VCSearch = 'vcSearch',
	RedirectToPromptuaryAfterVC = 'goToPromptuary',
	BtnExport = 'btnExport',
	BtnSave = 'btnSave',
	Page = 'page',
	Download = 'download',
	Modal = 'modal',
	ReceiptBtn = 'receiptBtn',
	CancelInviteBtn = 'cancelInviteBtn',
	CancelRescheduleBtn = 'cancelRescheduleBtn',
	ShowTriageBtn = 'showTriageBtn',
	Cancelation = 'cancelation',
	StartSpeechToTextBtn = 'StartSpeechToTextBtn',
	PromptuaryComplianceModal = 'promptuaryComplianceModal',
	InactiveCustomersBanner = 'InactiveCustomersBanner',
	SendMessageBtn = 'SendMessageBtn',
	ErrorSendMessage = 'ErrorSendMessage',
	CloseBtn = 'CloseBtn',
	RemoveCustomerToSendBulkMessage = 'RemoveCustomerToSendBulkMessage',
	AddCustomerToSendBulkMessage = 'AddCustomerToSendBulkMessage',
	ChangeDefaultMessage = 'ChangeDefaultMessage',
	PromptuaryQualityModal = 'promptuaryQualityModal',
	FeedScreen = 'feedScreen',
	FeedDelete = 'feedDelete',
	FeedCard = 'feedCard',
	SendInviteBtn = 'sendInviteBtn',
	Recurrency = 'recurrency',
	RecurrencyButton = 'recurrencyBtn',
	TierSugestion = 'tierSugestion',
	Tier = 'tier',
	ToolTip = 'tooltip',
	PaymentCard = 'paymentCard',
	TriageCard = 'triageCard',
	IsLgbt = 'isLgbt',
	SpecialtyType = 'specialtyType',
	DocumentaryRecord = 'documentary_record',
}

export enum INTERACTION_TYPE {
	RegisteredByMe = 'registeredByMe',
	RegisteredByOthers = 'registeredByOthers',
	AddedPlan = 'addedPlan',
	Check = 'check',
	Uncheck = 'uncheck',
	Cancel = 'cancel',
	Chat = 'chat',
	Click = 'click',
	Error = 'error',
	Finished = 'finished',
	Hangup = 'hangup',
	Joined = 'joined',
	KeepAlive = 'keepAlive',
	MuteAudio = 'muteAudio',
	MuteVideo = 'muteVideo',
	Open = 'open',
	Schedule = 'schedule',
	Seen = 'seen',
	ShareScreen = 'shareScreen',
	Success = 'success',
	Start = 'start',
	GoalComplete = 'goalComplete',
	Submit = 'submit',
	View = 'view',
	Close = 'close',
	Quit = 'quit',
	Continue = 'continue',
	Finish = 'finish',
	Undo = 'undo',
	Requested = 'requested',
	Sended = 'sended',
	Select = 'select',
}
